import { getDataSource } from 'legacy/store/appReducer';
import appStore from 'state/appStore';
import { DATASOURCES } from 'legacy/constants';

/**
 * File to abstract out ME data structure from the UI
 * so that identity/team/permissions data changes would be low impact.
 */

function hasMeData(me) {
  return me && me.data;
}

export function getMyTeam(
  me = getDataSource(appStore.getState(), DATASOURCES.ME),
) {
  if (hasMeData(me) && me.data.teams.length > 0) {
    return me.data.teams[0] || null;
  }
  return null;
}

export function getMyProfile(
  me = getDataSource(appStore.getState(), DATASOURCES.ME),
) {
  if (hasMeData(me) && me.data.profile) {
    return me.data.profile;
  }
  return null;
}

export function getMyPermissions(
  me = getDataSource(appStore.getState(), DATASOURCES.ME),
) {
  const profile = getMyProfile(me);
  if (profile && profile.permissions) {
    return profile.permissions;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/auth/state/userDataUtils.js